let credential;


export async function logout() {
  return await firebase.auth().signOut();
}

export async function sendSms(phoneNumber) {
  var appVerifier = window.recaptchaVerifier;

  const res = await firebase
    .auth()
    .signInWithPhoneNumber(phoneNumber, appVerifier);

  credential = res;
  console.log(res);
  return res;
}


export async function verifyCode(code) {
  if (!credential) return reject("Credential is null.");

  const res = await credential.confirm(code);
  console.log(res);
  return true;

}

export function listenToAuthState(authStateChanged) {
  firebase.auth().onAuthStateChanged(authStateChanged)
}
